
import { jsPDF } from "jspdf";
import QRCode from "qrcode";

const renderHindiToImage = (lines) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = 600;
  canvas.height = 300;
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "black";
  ctx.font = "bold 40px 'Arial', sans-serif";
  ctx.textAlign = "center";
  lines.forEach((line, i) => {
    ctx.fillText(line, canvas.width / 2, 60 + (i * 60));
  });
  return canvas.toDataURL("image/png");
};

export const generateCertificatePDF = async (data, certId) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4"
  });

  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();
  const centerX = width / 2;

  const verifyUrl = `${window.location.origin}/verify/${certId}`;
  const qrImage = await QRCode.toDataURL(verifyUrl, { margin: 1 });
  const hindiImage = renderHindiToImage([
    "न चोरहार्यं न च राजहार्यं",
    "न भ्रातृभाज्यं न च भारकारी।",
    "व्यये कृते वर्धत एव नित्यं",
    "विद्याधनं सर्वधनप्रधानम् ॥"
  ]);

  // 1. Background / Original Corner Design
  doc.setDrawColor(0, 102, 204);
  doc.setLineWidth(1);
  doc.rect(5, 5, width - 10, height - 10);
  doc.setLineWidth(0.5);
  doc.rect(7, 7, width - 14, height - 14);

  doc.setFillColor(0, 102, 204);
  doc.triangle(0, 0, 60, 0, 0, 60, 'F');
  doc.setFillColor(200, 200, 200);
  doc.triangle(10, 0, 50, 0, 0, 40, 'F');
  doc.setFillColor(0, 102, 204);
  doc.triangle(width, height, width - 60, height, width, height - 60, 'F');

  // 1.5 Student Photo (Top Left)
  if (data.photo) {
    try {
      doc.setDrawColor(0, 102, 204);
      doc.setLineWidth(0.5);
      doc.rect(12, 12, 30, 40);
      // Let jsPDF detect format from data URL
      doc.addImage(data.photo, 12.5, 12.5, 29, 39);
    } catch (e) {
      console.error("Error adding photo to PDF", e);
    }
  }

  // 2. Header - Centered (Y moved up)
  doc.setTextColor(200, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(30);
  doc.text("PANKAJ COMPUTERS", centerX + 20, 25, { align: "center" });

  doc.setTextColor(0);
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text("GSTIN: 08AAHPO1256F1ZS / BRN: 8004510008000025 / Udyog Aadhaar: RJ15D00011543", centerX+20, 12, { align: "center" });

  doc.setFontSize(11);
  doc.text(`No. : ${data.certNo}`, 85, 40);
  doc.text(`Date : ${data.date}`, width - 50, 40);

  // 3. Title (Tighter spacing)
  doc.setTextColor(200, 0, 0);
  doc.setFontSize(24);
  doc.text("CERTIFICATE", centerX + 20, 52, { align: "center" });

  // 4. Main Content (Tightened vertical gaps)
  doc.setTextColor(0);
  doc.setFont("helvetica", "italic");
  doc.setFontSize(16);
  doc.text("This is to certify that", centerX + 20, 62, { align: "center" });

  doc.setTextColor(0, 51, 153);
  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(24);
  doc.text(data.studentName, centerX + 20, 75, { align: "center" });

  doc.setTextColor(0);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(`(R/o ${data.residence})`, centerX + 20, 83, { align: "center" });

  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(16);
  doc.text("has successfully completed", centerX + 20, 95, { align: "center" });

  doc.setTextColor(0, 51, 153);
  doc.setFontSize(20);
  doc.text(data.courseName.toUpperCase(), centerX + 20, 108, { align: "center" });

  doc.setTextColor(0);
  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(16);
  doc.text("Now candidate is able to working with", centerX + 20, 120, { align: "center" });

  doc.setTextColor(0, 51, 153);
  doc.setFontSize(15);
  doc.text(data.skills.toUpperCase(), centerX + 20, 132, { align: "center" });

  doc.setTextColor(0);
  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(15);
  doc.text("We wish the candidate all the best in future endeavors.", centerX + 20, 145, { align: "center" });

  // 5. Dynamic Signatures
  const sigY = 170;
  const sigCount = (data.signatories && data.signatories.length > 0) ? data.signatories.length : 0;
  
  if (sigCount > 0) {
    const sectionWidth = width / sigCount;
    data.signatories.forEach((sig, index) => {
      const sigX = (sectionWidth * index) + (sectionWidth / 2);
      
      // Signature Image
      if (sig.signatureUrl) {
        try {
          doc.addImage(sig.signatureUrl, 'PNG', sigX - 15, sigY - 15, 30, 12);
        } catch (e) {
          console.error("Error adding signature image", e);
        }
      }

      // Signature Line
      doc.setDrawColor(0, 102, 204);
      doc.setLineWidth(0.5);
      doc.line(sigX - 30, sigY, sigX + 30, sigY);

      // Name & Designation
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text(sig.name.toUpperCase(), sigX, sigY + 5, { align: "center" });
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(sig.designation, sigX, sigY + 10, { align: "center" });
    });
  } else {
    // Fallback to original hardcoded signatures if none selected (Legacy Support)
    doc.setDrawColor(0, 102, 204);
    doc.line(40, sigY, 100, sigY);
    doc.line(width - 100, sigY, width - 40, sigY);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("PANKAJ OJHA", 70, sigY + 5, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text("Managing Director", 70, sigY + 10, { align: "center" });

    doc.setFont("helvetica", "bold");
    doc.text("SONIA OJHA", width - 70, sigY + 5, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text("Director", width - 70, sigY + 10, { align: "center" });
  }

  // 6. QR Code - Centered in side space
  doc.addImage(qrImage, 'PNG', width - 40, 50, 25, 25);
  doc.setFontSize(7);
  doc.text("Scan to Verify", width - 27.5, 78, { align: "center" });

  // 7. Footer - Positioned strictly at bottom
  doc.setFontSize(10);
  doc.text("Office: Patrakar Colony, Behind Tehhsil Campus, Anupgarh-335701, (Raj.) INDIA,", centerX + 10, height - 12, { align: "center" });
  doc.setFontSize(8);
  doc.text("Mob. : +91-9414537189, +91-97822-43089 Email : pankaj250483@gmail.com, contactus@pankajcomputers.com, Visit us : www.pankajcomputers.com", centerX , height - 8, { align: "center" });

  // 8. Sanskrit Quote - Left Side (Tightened box)
  doc.setDrawColor(200, 200, 200);
  doc.rect(15, 65, 40, 65);
  doc.addImage(hindiImage, 'PNG', 16, 68, 38, 18);
  
  doc.setFontSize(7);
  const quoteDesc = "No one can steal it, not authority can snatch, Not divided in brothers, not heavy to carry, As you consume or spend, it increases; as you share, it expands, Education (Vidhya) Is the best wealth among all the wealth anyone can have.";
  doc.text(doc.splitTextToSize(quoteDesc, 35), 35, 90, { align: "center" });

  doc.save(`${data.studentName}_Certificate.pdf`);
};
